export default __webpack_public_path__ + "static/art-direction_desktop-b82bfa3da63a6c1285d3b13bb5702675.jpg";